import React from 'react';

export function LegalNoticeStrip() {
  return (
    <div className="bg-white border-t-2 border-b-2 border-black">
      <div className="max-w-6xl mx-auto px-6 py-4 text-xs text-slate-700">
        Non-transferable. Not tradable. High-risk. No guaranteed returns. Read the Terms before investing.
      </div>
    </div>
  );
}


